// extracted by mini-css-extract-plugin
module.exports = {"Card":"PersonalityCard_Card__34Pwq","TestName":"PersonalityCard_TestName__313B5","Icon":"PersonalityCard_Icon__2N-Hd"};